module.exports = __webpack_public_path__ + "img/chickenbites.0d4650b0.jpg";